import { isPlatform } from '@ionic/react';

export const isMobileDevice = () => {
  return (
    isPlatform('hybrid') || // capacitor native
    isPlatform('mobile') || // generic mobile
    isPlatform('ios') ||
    isPlatform('android')
  );
};
